import React from "react";

const QuickBooksGlyph = ({ className }) => (
	<svg className={className} viewBox="0 0 32 32" aria-hidden="true">
		<circle cx="16" cy="16" r="16" fill="#2CA01C" />
		<text x="16" y="21" textAnchor="middle" fontSize="13" fontWeight="700" fill="#ffffff" fontFamily="Modern Era, Arial, sans-serif">qb</text>
	</svg>
);

export default QuickBooksGlyph;
